<template>
  <div class="page-container" style="min-height: auto;">
    <div class="page-title-container">
      <h1 class="title-text">Dashboard</h1>
    </div>

    <div class="dashboard-plan-name-container" style="margin-top: 1rem;">
      <button @click="$router.push({ path: '/dashboard' })" class="secondary-button small-button" type="button">
        <i class="fas fa-arrow-left previous-page-button-icon"></i> Back to Dashboard
      </button>
    </div>

    <div class="page-title-container">
      <h2 class="subtitle-text">JOB OFFER DETAILS</h2>
    </div>

    <div v-if="isLoaded === true">
      <div v-if="job == null">
        <h1>Not found</h1>
      </div>
    </div>

    <div v-if="job != null">
      <div class="dashboard-container" style="margin-bottom: 3rem;">
        <p>
          👤 Job title: <b>{{ job.jobTitle }}</b>
        </p>
        <p>
          🏢 Company: <b>{{ job.companyName }}</b>
        </p>
        <p>
          ✅ Sent: <b>{{ job.completedCount }} sites</b>
        </p>
        <p>
          🕓 Pending: <b>{{ job.pedingCount }} sites</b>
        </p>
        <p>
          ⚠️ Unable to complete: <b>{{ job.unableToCompleteCount }} sites</b>
        </p>
      </div>

      <div class="page-subtitle-container">
        <h2 class="subtitle-text">
          SITES
        </h2>
      </div>

      <div class="dashboard-status-container">
        <div class="dashboard-panel-status" :key="`sites-${i}`" v-for="(s, i) in sitesPaginated">
          <p v-if="s.state === 'completed'"><b>✅ Sent</b></p>
          <p v-if="s.state === 'pending'">🕓 Pending</p>
          <div v-if="s.state === 'unableToComplete'">
            <p><b>⚠️ Unable to complete</b></p>
            <p>Reason: {{ s.reasonUnableToComplete }}</p>
          </div>

          <div class="website-name-container">
            <a class="dashboard-details-site-name">{{ s.site.name }}</a>
            &nbsp;
            <div class="dashboard-image-icon-container">
              <img class="image-hero" :src="s.logo" />
            </div>
          </div>
        </div>
      </div>

      <div class="pagination-container">
        <button v-if="currentPage !== 0" @click="previous()" class="secondary-button small-button pagination-button">
          <i class="fas fa-arrow-left previous-page-button-icon"></i> Previous
        </button>
        <button v-if="m()" @click="next()" class="secondary-button small-button">
          Next <i class="fas fa-arrow-right next-page-button-icon"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase";
import utils from "@/utils";

export default {
  created() {
    window.scrollTo(0, 0);
  },

  data() {
    return {
      job: null,
      utils,
      itemsPerPage: 5,
      currentPage: 0,
      isLoaded: false,
    };
  },

  computed: {
    sitesPaginated() {
      return this.job.jobSites.slice(this.currentPage * this.itemsPerPage, this.currentPage * this.itemsPerPage + this.itemsPerPage);
    },
  },

  methods: {
    m() {
      const maxPages = Math.trunc(this.job.jobSites.length / this.itemsPerPage);
      return this.currentPage + 1 < maxPages;
    },

    async getSite() {
      const Paddle = window.Paddle;
      Paddle.Spinner.show();
      this.isLoaded = false;

      const job = await firebase.functions.httpsCallable("getJobById")({
        id: this.$route.params.id,
      });

      const p = job.data.jobSites.map(async (x) => {
        x.logo = await utils.getUrlFromPath(x.site.logoPath);
        return x;
      });

      job.data.jobSites = await Promise.all(p);

      this.job = job.data;

      Paddle.Spinner.hide();
      this.isLoaded = true;
    },

    next() {
      this.currentPage++;
      window.scrollTo(0, 0);
    },

    previous() {
      this.currentPage--;
      window.scrollTo(0, 0);
    },
  },

  mounted() {
    this.getSite();
  },
};
</script>

<style>
.page-subtitle-container {
  text-align: center;
}
</style>
